export enum UserManagementSubnavigationItems {
    EMPLOYEES = 'employees',
    BRINGING_CUSTOMERS = 'bringing-customers',
}
